<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_LandTransportationDetails')"
    width="940px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="land-transportation-form-dialog details-view"
  >
    <el-form
      label-width="70px"
      label-position="left"
    >
      <el-row :gutter="10">
        <el-col
          :span="6"
        >
          <el-form-item :label="$t('SeaExport.Quantity')">
            <el-input-number
              v-model="data.quantity"
              controls-position="right"
              :min="0"
              disabled
              :max="99999"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="6"
        >
          <el-form-item :label="$t('SeaExport.Weight2')">
            <el-input-number
              v-model="data.weight"
              controls-position="right"
              :min="0"
              disabled
              :max="99999"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="6"
        >
          <el-form-item :label="$t('SeaExport.Cubage')">
            <el-input-number
              v-model="data.cubage"
              controls-position="right"
              :min="0"
              disabled
              :max="99999"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="6"
        >
          <el-form-item label="S/O No">
            <el-input
              v-model="soNo"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="labelPage" :title="$t('SeaExport.HaulageCompany')">{{ $t('SeaExport.HaulageCompany') }}</span>
            <cargo-company-select
              :method-params="{truckCmp:true,active:true}"
              :default-value="data.carryingCmp||''"
              disabled
              @change="p=>{data.carryingCmp=p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="labelPage" :title="$t('SeaExport.HaulageNo')">{{ $t('SeaExport.HaulageNo') }}</span>
            <el-input
              v-model="data.truckOrderNo"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item>
            <span slot="label" class="labelPage" :title="$t('SeaExport.HaulageContactPerson')">{{ $t('SeaExport.HaulageContactPerson') }}</span>
            <el-select
              v-model="data.driver"
              :allow-create="true"
              clearable
              filterable
              @change="carryingContactsChangeHandler(false, false)"
              @blur="selectContactBlur"
            >
              <el-option
                v-for="(item,index) in contactArray"
                :key="index"
                :label="item.contactPerson"
                :value="item.contactPerson"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <span slot="label" class="labelPage">{{ $t('SeaExport.Tel') }}</span>
            <el-input v-model="data.driverTel" :disabled="false" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="100px">
            <span slot="label" class="labelPage" :title="$t('SeaExport.CargosExpectedArrivalDatePacking')">{{ $t('SeaExport.CargosExpectedArrivalDatePacking') }}</span>
            <cargo-date-time-field-input v-model="data.loadingDate" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Door')">
            <el-input v-model="data.doorName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('SeaExport.ZIP')">
            <el-input v-model="data.zipCode" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item>
            <span slot="label" class="labelPage" :title="$t('SeaExport.DoorContactPerson')">{{ $t('SeaExport.DoorContactPerson') }}</span>
            <el-input v-model="data.doorMan" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="data.doorManTel" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item>
            <span slot="label" class="labelPage" :title="$t('SeaExport.DoorAddress')">{{ $t('SeaExport.DoorAddress') }}</span>
            <textarea v-model="data.doorAddr" disabled style="min-width: 100%; min-height: 100px" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item>
            <span slot="label" class="labelPage" :title="$t('SeaExport.AdditionalNotes')">{{ $t('SeaExport.AdditionalNotes') }}</span>
            <textarea v-model="data.remarks" disabled style="min-width: 100%; min-height: 100px" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" style="width: fit-content; float: right">
      <el-button type="success" :disabled="data.printState === 1" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('SeaExport.Save') }}</el-button>
      <el-button @click="onCancel">{{ $t('SeaExport.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import NumericStepper from '@/views/cargo/v0/Price/components/numericStepper'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import PairNumericStepper from '@/views/cargo/v0/Price/components/pairNumericStepper'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import { getContacts } from '@/api/partner/contact'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'LandTransportationForm',
  components: {
    CargoDateTimeFieldInput,
    CargoUserSelect,
    CargoCompanySelect,
    CargoTemplateSelectDialog,
    PairNumericStepper, CargoAgGrid, cargoAdvanceSelect, NumericStepper,
    cargoRichTextarea, cargoCloudFileUpload },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      contactArray: []
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.selectRow = null
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    soNo: {
      get() {
        return StrUtils.isEmpty(this.data.soNo) ? '' : this.data.soNo.split('\n')[0]
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('close')
    },
    onSave() {
      this.$emit('save', this.data)
      this.$emit('close')
    },
    onPrint() {
      this.$emit('print', this.data)
    },
    // 加载指定合作伙伴所维护的联系人
    loadContacts() {
      getContacts({ cmpIdx: this.data.carryingCmp }).then(res => {
        if (res.data) {
          this.contactArray = res.data
        }
      }).catch(error => {
        console.log('getContacts error', error)
      })
    },
    carryingContactsChangeHandler() {
      if (!this.data || !this.data.driver) return
      if (this.contactArray && this.contactArray.length > 0) {
        for (const item of this.contactArray) {
          if (item && item.contactPerson && item.contactPerson === this.data.driver) {
            this.data.driverTel = item.telephone
            break
          }
        }
      } else {
        this.data.driver = ''
      }
    },
    selectContactBlur(event) {
      if (event && event.target && event.target.value) {
        this.data.driver = event.target.value
      }
    }
  }
}
</script>

<style scoped>
</style>
<style lang="scss">
.land-transportation-form-dialog{
  .el-input-number{
    width: 100%;
  }
}

.labelPage {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
